<template>
  <div class="dropdown mt-4" id="drop" style="width: 100%">
    <button
      class="btn dropdown-toggle w-100 d-flex align-items-center"
      type="button"
      :id="dropdownId"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style="gap: 10px; height: 50px; transform: translateY(-17px);"
    >
      <span class="flex-grow-1 text-start">
        {{
          selected
            ? selected.gradeName + " - " + (selected.number || "")
            : placeholder
        }}
      </span>
    </button>
    <ul
      class="dropdown-menu w-100 pb-0"
      :aria-labelledby="dropdownId"
      style="overflow: auto;"
    >
      <li v-for="item in items" :key="item.id">
        <a
          class="dropdown-item"
          href="#"
          @click.prevent="select(item)"
        >
          {{ item.gradeName }} - {{ item.number || "" }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ClassDropdown",
  props: {
    items: { type: Array, required: true },
    selected: { type: Object, default: null },
    placeholder: { type: String, default: "Sélectionner une classe" },
    dropdownId: { type: String, default: "dropdownMenuButton" }
  },
  methods: {
    select(item) {
      this.$emit("select", item);
    }
  }
};
</script>

<style scoped>
 #drop .btn {
  width: 100%;
  background: #051139;
  
}
#drop .dropdown-menu{
  border-radius: 0px;
  background-color: #051139;
  border: 1px 1px 0px 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 0px ;
}
#drop .dropdown-item{
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  height: 45px;
  padding-top: 10px;
}
#drop .dropdown-item:hover{
  
  color: black; 

}
</style>